import React, { useMemo, useRef } from 'react';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import Slide from './Slide';
import { SliderWrapper } from './InfoSlider.style';
import ChevronBackIcon from './icons/chevron-back.svg?react';
import ChevronForvardIcon from './icons/chevron-forward.svg?react';
import { useIntl } from 'react-intl';

const InfoSlider = () => {
  const swiperRef = useRef<SwiperRef | null>(null);

  const intl = useIntl();

  const slides = useMemo(
    () => [
      {
        id: 1,
        img: 'https://firebasestorage.googleapis.com/v0/b/ihub-projects-developmen-af75f.appspot.com/o/onBoarding%2Fslides%2Fslide_1.jpg?alt=media&token=cdf513e5-d186-471a-9c9f-7d25f096de09',
        text: `"${intl.formatMessage({
          id: 'on-boarding.slide.review.1.text',
          defaultMessage:
            'Робота з психологом Mindly допомогла мені повністю позбутись тривожного стану і спокійніше реагувати на все, що відбувається навколо.',
        })}"`,
        name: intl.formatMessage({
          id: 'on-boarding.slide.review.1.name',
          defaultMessage: 'Катя',
        }),
        position: intl.formatMessage({
          id: 'on-boarding.slide.review.1.position',
          defaultMessage: 'маркетолог, 26 років',
        }),
      },
      {
        id: 2,
        img: 'https://firebasestorage.googleapis.com/v0/b/ihub-projects-developmen-af75f.appspot.com/o/onBoarding%2Fslides%2Fslide_2.jpg?alt=media&token=038e9473-bf1e-4f72-bedf-a26c4ac9f21e',
        text: `"${intl.formatMessage({
          id: 'on-boarding.slide.review.2.text',
          defaultMessage:
            'Дуже радий, що обрав роботу з психологом, бо це значно потужніший інструмент ніж здається. Mindly класно допоміг мені - можливо допоможе і тобі!',
        })}"`,
        name: intl.formatMessage({
          id: 'on-boarding.slide.review.2.name',
          defaultMessage: 'Віталій',
        }),
        position: intl.formatMessage({
          id: 'on-boarding.slide.review.2.position',
          defaultMessage: 'програміст, 28 років',
        }),
      },
      {
        id: 3,
        img: 'https://firebasestorage.googleapis.com/v0/b/ihub-projects-developmen-af75f.appspot.com/o/onBoarding%2Fslides%2Fslide_3.jpg?alt=media&token=0f68d9e0-fd46-4c04-bed2-5b17ef284f62',
        text: `"${intl.formatMessage({
          id: 'on-boarding.slide.review.3.text',
          defaultMessage: 'Робота з психологом допомогла мені краще впоратись із тривогою та переживаннями.',
        })}"`,
        name: intl.formatMessage({
          id: 'on-boarding.slide.review.3.name',
          defaultMessage: 'Катя',
        }),
        position: intl.formatMessage({
          id: 'on-boarding.slide.review.3.position',
          defaultMessage: 'менеджер коворкінгу, 31 рік',
        }),
      },
    ],
    [intl]
  );

  return (
    <SliderWrapper>
      <button className="back-arrow" onClick={() => swiperRef.current?.swiper.slidePrev()}>
        <ChevronForvardIcon />
      </button>
      <Swiper ref={swiperRef} spaceBetween={0} slidesPerView={1} loop>
        {slides.map((s) => (
          <SwiperSlide key={s.id}>
            <Slide data={s} />
          </SwiperSlide>
        ))}
      </Swiper>
      <button className="forward-arrow" onClick={() => swiperRef.current?.swiper.slideNext()}>
        <ChevronBackIcon />
      </button>
    </SliderWrapper>
  );
};

export default InfoSlider;
